import React, { useState, useEffect } from "react";
import { Paper, Divider, Box } from "@mui/material";
import BroadcastOnHomeIcon from "@mui/icons-material/BroadcastOnHome";
import FaxIcon from "@mui/icons-material/Fax";
import axios from "axios";
import { ToolBar } from "../../components/toolbar";
import { Modal } from "../../components/modal";
import { FormA } from "../../components/form";
import { getFormState } from "../../../helpers/form";
import { Notice } from "../../components/notice";
import { CONFIG } from "../../../config";

const API_HOST = CONFIG.modules["accounts"].host;
const fieldsMap = {
	Departments: [
		{
			type: "select",
			label: "Select Department Type",
			option: { key: "department_types", value: "_id", label: "name" },
			required: true,
			name: "type",
		},
		{
			type: "text",
			label: "Name",
			required: true,
			name: "name",
		},
	],
};

const Projects = ({ getSelectedDepartment, setSelectedDepartment }) => {
	const [departments, setDepartments] = useState([]);
	const [projects, setProjects] = useState([]);
	const [open, setOpen] = useState(false);
	const [action, setAction] = useState("new");
	const [active, setActive] = useState("Departments");
	const [formData, setFormData] = useState(getFormState(fieldsMap[active]));
	const [savedMessage, setSavedMessage] = useState(false);

	const getProjectsAndDepartments = () => {
		axios
			.get(API_HOST + `/get-projects-and-departments`)
			.then((resp) => {
				if (resp.data && resp.data.success) {
					setDepartments(resp.data?.departments);
					setProjects(resp.data?.projects);
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};

	useEffect(() => {
		getProjectsAndDepartments();
	}, []);

	const handleSubmit = () => {
		axios
			.post(API_HOST + "/entity", {
				entityName: active,
				payload: formData,
			})
			.then((resp) => {
				if (resp.data && resp.data.success) {
					setOpen(false);
					const newEntry = resp.data.data;
					if (formData.type === "Project Based") {
						setProjects((prevState) => [newEntry, ...prevState]);
					} else {
						setDepartments((prevState) => [newEntry, ...prevState]);
					}
					setSavedMessage("Great! New Department/Project Saved");
					setTimeout(() => {
						setSavedMessage(null);
					}, 2000);
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};

	return (
		<>
			{savedMessage && <Notice text={savedMessage} />}
			<div className="section">
				<Paper>
					<div className="container">
						<div className="row justify-content-end">
							<div className="m-2">
								{/* <Button variant="contained" size="small" >
									+Add New
								</Button> */}
								<ToolBar
									buttons={[
										{
											name: "Add new",
											onClick: () => {
												setAction("new");
												setFormData(getFormState(fieldsMap[active]));
												setOpen(true);
											},
										},
									]}
								/>
							</div>
						</div>

						<div className="row">
							<div className="col-md-6 p-2">
								<div className="text-center m-2">
									<strong>
										<h4> Departments </h4>
									</strong>
								</div>
								<Divider />

								<div className="row">
									<div className="col-12 p-3">
										{departments.length > 0 &&
											departments.map((department) => (
												<div
													className="m-3 border border-success rounded p-3"
													onClick={() => {
														getSelectedDepartment(department._id)
														setSelectedDepartment(department)
													}}
													key={department._id}
												>
													<div className="btn d-flex justify-content-between">
														<div>
															<strong>{department.name}</strong>
														</div>
														<div>
															<FaxIcon />
														</div>
													</div>
												</div>
											))}
									</div>
								</div>
							</div>

							<div className="col-md-6 p-2">
								<div className="text-center m-2">
									<strong>
										<h4> Projects </h4>
									</strong>
								</div>
								<Divider />

								<div className="row">
									<div className="col-12 p-3">
										{projects.length > 0 &&
											projects.map((project) => (
												<div
													className="m-3 border border-success rounded p-3"
													onClick={() => {

														getSelectedDepartment(project._id)
														setSelectedDepartment(project)
													}}

													key={project._id}
												>
													<div className="btn d-flex justify-content-between">
														<div>
															<strong>{project.name}</strong>
														</div>
														<div>
															<BroadcastOnHomeIcon />
														</div>
													</div>
												</div>
											))}
									</div>
								</div>
							</div>
						</div>
					</div>
				</Paper>
			</div>

			<Modal
				open={open}
				handleClose={() => {
					setOpen(false);
				}}
				head={`${action == "new" ? "Add" : "Edit"} ${active}/Project`}
				buttons={[
					{
						name: "Cancel",
						onClick: () => {
							setOpen(false);
						},
					},
					{
						name: action == "new" ? "Create" : "Save",
						onClick: () => {
							switch (action) {
								case "new":
									handleSubmit();
									break;
								default:
									break;
							}
						},
					},
				]}
			>
				{Array.isArray(fieldsMap[active]) && (
					<Box sx={{ mt: 2 }}>
						<FormA
							fields={fieldsMap[active]}
							data={{
								department_types: [
									{
										_id: "Core",
										name: "Core",
									},
									{
										_id: "Project Based",
										name: "Project Based",
									},
									{
										_id: "Internal Team",
										name: "Internal Team",
									},
								],
							}}
							onChange={(name, value, multiple) => {
								formData[name] = value;
								setFormData({ ...formData });
							}}
							state={formData || {}}
						/>
					</Box>
				)}
			</Modal>
		</>
	);
};

export default Projects;
